import { HomeOutlineIcon, PersonAddOutlineIcon, PersonOutlineIcon, SvgIconProps } from '@applyboard/ui-icons';
import { Action, ProfileData } from '../../../clients';
import { hasPermission } from '../../../utils/auth';
import { DesktopSidebar } from './DesktopSidebar';
import { MobileSidebar } from './MobileSidebar';

const MENU_LABELS = ['Home', 'Search', 'All Users', 'Create User'] as const;
export type MenuItemLabel = (typeof MENU_LABELS)[number];

type SidebarProps = {
  isDesktopSidebarOpen: boolean;
  isMobileSidebarOpen: boolean;
  onMobileSidebarOpenChange: (open: boolean) => void;
  profile: ProfileData;
  selectedMenuItem: MenuItemLabel;
};

export type NavBarItems = {
  id: string;
  href: string;
  label: MenuItemLabel;
  icon: React.ComponentType<Omit<SvgIconProps, 'children'>>;
  selected?: boolean;
};

export function Sidebar(props: SidebarProps) {
  const navBarPrimaryItems: Array<NavBarItems> = [
    {
      id: crypto.randomUUID(),
      href: '/',
      label: 'Home',
      icon: HomeOutlineIcon,
      selected: props.selectedMenuItem === 'Home',
    },
    {
      id: crypto.randomUUID(),
      href: '/profiles/school-users',
      label: 'All Users',
      icon: PersonOutlineIcon,
      selected: props.selectedMenuItem === 'All Users',
    },
  ];

  return (
    <>
      <MobileSidebar
        open={props.isMobileSidebarOpen}
        onOpenChange={props.onMobileSidebarOpenChange}
        navbarItems={navBarPrimaryItems}
      />
      <DesktopSidebar open={props.isDesktopSidebarOpen} primaryNavBarItems={navBarPrimaryItems} />
    </>
  );
}
